var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86667 0H0V9.66102H5.13333V15H14V5.33898H8.86667V0ZM3.8589 2.28814L2.39438 6.84216H3.38333L3.62151 6.1017H5.13333V8.64407H0.933333V1.01695H7.93333V5.33898H5.98885L5.00792 2.28814H3.8589ZM4.91814 5.08475H3.94853L4.43333 3.57718L4.91814 5.08475ZM13.0667 6.35593V13.9831H6.06667V6.35593H13.0667Z",
    fill: "#9997A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79177 10.9475C8.88104 11.1037 8.97932 11.2535 9.08603 11.3962C8.7477 11.595 8.36346 11.6946 7.93333 11.6949V12.7119C8.63745 12.7119 9.26654 12.5082 9.8 12.1136C10.3335 12.5082 10.9626 12.7119 11.6667 12.7119V11.6949C11.2374 11.6949 10.8532 11.5953 10.514 11.396C10.6207 11.2534 10.719 11.1036 10.8082 10.9475C11.0772 10.471 11.2751 9.95091 11.3943 9.40678H11.9V8.38983H10.2667V7.62712H9.33333V8.38983H7.7V9.40678H8.20569C8.32494 9.95091 8.52276 10.471 8.79177 10.9475ZM10.428 9.40678C10.3314 9.75873 10.1932 10.0955 10.0167 10.4085C9.95078 10.5239 9.87841 10.6348 9.8 10.7405C9.72729 10.6426 9.65981 10.5402 9.59788 10.4338C9.41426 10.1138 9.27099 9.76839 9.17193 9.40678H10.428Z",
    fill: "#9997A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/languageIcon.ed1f4d9d.svg";
export { ForwardRef as ReactComponent };